import React, { Component } from 'react';
import css from './css/contact.module.scss';

import Layout from 'cps/layout';

import banner from 'img/about/banner.jpg';
import map from 'img/about/about_map_new.png';

class Contact extends Component{

  render() {
    return (
      <Layout title="联系我们">
      <div className={css.wrap}>
       <img src={banner} alt="联系我们" className={css.banner}/>
       <div className={css.contact}>
          <div className={css.contactLeft}>
              <h2>杭州博科思科技有限公司</h2>
              <p>
              地址： 杭州市滨江区物联网街259号初灵数据大厦19楼<br/>
              邮编： 310051<br/>
              电话： (0571)-87178266<br/>
              传真： (0571)-87178266-8305<br/>
              Email： job@51box.cn<br/>
              </p>
              <h3>公交路线</h3>
              <p>西兴路物联网街口：355路、96路、信息港通勤线<br/>
                 西兴路月明路口：96路<br/>
                 新联路月明路口：355路、信息港通勤线、信息港通勤线高峰<br/>
                 物联网街阡陌路口：355路、信息港通勤线高峰<br/>
                 物联网园区：义桥-物联网园区<br/>
                 新州花苑北：137路/137（M）路、195H路、96路<br/>
              </p>
              <h3>地铁路线</h3>
              <p>江陵路地铁站D口右转，走1.5公里。</p>
          </div>
          <img className={css.contactRighgt} src={map} alt="map"/>
       </div>
      </div>
      </Layout>
    )
  }
}


export default Contact
